var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9h16V7H4v2zm0 3v6h16v-6H4zm0-7h16c1.105 0 2 .895 2 2v11c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2V7c0-1.105.895-2 2-2zm3 9h3c.552 0 1 .448 1 1s-.448 1-1 1H7c-.552 0-1-.448-1-1s.448-1 1-1zm6 0h1c.552 0 1 .448 1 1s-.448 1-1 1h-1c-.552 0-1-.448-1-1s.448-1 1-1z"
  })));
};
export default SvgCreditCard;